<template>
  <div id="banner">
    <v-row no-gutters justify="center" align="center" class="mx-0">
      <serviceworker id="serviceworker"></serviceworker>
    </v-row>
    <v-row no-gutters justify="center" align="center" class="mx-0">
      <warning></warning>
    </v-row>
  </div>
</template>

<script>
  import serviceworker from '@/components/layouts/ServiceWorker'
  import warning from '@/components/layouts/Warning'

  export default {
    name: 'AppStatus',
    components: { serviceworker, warning },
    data() {
      return {
        error: false,
        message: '',
        error: { start: false },
      }
    },
  }
</script>
